export const SCOPE = 'module:errorDiagnostics';

export const INIT = `${SCOPE}/INIT`;
